import { render, staticRenderFns } from "./AddCompanyView.vue?vue&type=template&id=7a8dbd0f&"
import script from "./AddCompanyView.vue?vue&type=script&lang=ts&"
export * from "./AddCompanyView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports